<template>
  <div class="content">
    <h1 class="is-hidden">Datenschutzerkärung</h1>
    <div class="box">
      <p>
        Wir haben diese Datenschutzerklärung (Fassung 18.02.2019-211087012) verfasst, um Ihnen gemäß der Vorgaben der
        Datenschutz-Grundverordnung (EU) 2016/679 und dem Datenschutzgesetz (DSG) zu erklären, welche Informationen wir
        sammeln, wie wir Daten verwenden und welche Entscheidungsmöglichkeiten Sie als Besucher dieser Webseite haben.
      </p>
      <p>
        Leider liegt es in der Natur der Sache, dass diese Erklärungen sehr technisch klingen, wir haben uns bei der
        Erstellung jedoch bemüht die wichtigsten Dinge so einfach und klar wie möglich zu beschreiben.
      </p>
      <h2>Automatische Datenspeicherung</h2>
      <p>
        Wenn Sie heutzutage Webseiten besuchen, werden gewisse Informationen automatisch erstellt und gespeichert, so auch
        auf dieser Webseite.
      </p>
      <p>
        Wenn Sie unsere Webseite so wie jetzt gerade besuchen, speichert unser Webserver (Computer auf dem diese Webseite
        gespeichert ist) automatisch Daten wie
      <ul>
        <li>die Adresse (URL) der aufgerufenen Webseite</li>
        <li>Browser und Browserversion</li>
        <li>das verwendete Betriebssystem</li>
        <li>den Hostname und die IP-Adresse des Geräts von welchem aus zugegriffen wird</li>
        <li>die Adresse (URL) der zuvor besuchten Seite (Referrer URL)</li>
        <li>Datum und Uhrzeit</li>
      </ul>
      in Dateien (Webserver-Logfiles).
      </p>
      <p>
        In der Regel werden Webserver-Logfiles zwei Wochen gespeichert und danach automatisch gelöscht. Wir geben diese
        Daten nicht weiter, können jedoch nicht ausschließen, dass diese Daten beim Vorliegen von rechtswidrigem Verhalten
        eingesehen werden.
        Die Rechtsgrundlage besteht nach Artikel 6 Absatz 1 f DSGVO (Rechtmäßigkeit der Verarbeitung) darin, dass
        berechtigtes Interesse daran besteht, den fehlerfreien Betrieb dieser Webseite durch das Erfassen von
        Webserver-Logfiles zu ermöglichen.
      </p>
      <h2 class="is-wordWrapBreakWord">Rechte laut Datenschutzgrundverordnung</h2>
      <p>
        Ihnen stehen laut den Bestimmungen der DSGVO und des österreichischen Datenschutzgesetzes (DSG) grundsätzlich die
        folgende Rechte zu:
      <ul>
        <li>Recht auf Berichtung (Artikel 16 DSGVO)</li>
        <li>Recht auf Löschung („Recht auf Vergessenwerden“) (Artikel 17 DSGVO)</li>
        <li>Recht auf Einschränkung der Verarbeitung (Artikel 18 DSGVO)</li>
        <li>Recht auf Benachrichtigung – Mitteilungspflicht im Zusammenhang mit der Berichtigung oder Löschung
          personenbezogener Daten oder der Einschränkung der Verarbeitung (Artikel 19 DSGVO)</li>
        <li>Recht auf Datenübertragbarkeit (Artikel 20 DSGVO)</li>
        <li>Widerspruchsrecht (Artikel 21 DSGVO)</li>
        <li>Recht, nicht einer ausschließlich auf einer automatisierten Verarbeitung — einschließlich Profiling —
          beruhenden Entscheidung unterworfen zu werden (Artikel 22 DSGVO)</li>
      </ul>
      Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt oder Ihre
      datenschutzrechtlichen Ansprüche sonst in einer Weise verletzt worden sind, können Sie sich bei der Aufsichtsbehörde
      beschweren, welche in Österreich die Datenschutzbehörde ist, deren Webseite Sie unter https://www.dsb.gv.at/ finden.
      </p>
      <h2>Auswertung des Besucherverhaltens</h2>
      <p>
        In der folgenden Datenschutzerklärung informieren wir Sie darüber, ob und wie wir Daten Ihres Besuchs dieser
        Website auswerten. Die Auswertung der gesammelten Daten erfolgt in der Regel anonym und wir können von Ihrem
        Verhalten auf dieser Website nicht auf Ihre Person schließen.
      </p>
      <p>
        Mehr über Möglichkeiten dieser Auswertung der Besuchsdaten zu widersprechen erfahren Sie in der folgenden
        Datenschutzerklärung.
      </p>
      <h2>TLS-Verschlüsselung mit https</h2>
      <p>
        Wir verwenden https um Daten abhörsicher im Internet zu übertragen (Datenschutz durch Technikgestaltung Artikel 25
        Absatz 1 DSGVO). Durch den Einsatz von TLS (Transport Layer Security), einem Verschlüsselungsprotokoll zur
        sicheren Datenübertragung im Internet können wir den Schutz vertraulicher Daten sicherstellen. Sie erkennen die
        Benutzung dieser Absicherung der Datenübertragung am kleinen Schlosssymbol links oben im Browser und der
        Verwendung des Schemas https (anstatt http) als Teil unserer Internetadresse.
      </p>
      <!--
      <h2>Cookies</h2>
      <p>
        Unsere Website verwendet HTTP-Cookies um nutzerspezifische Daten zu speichern.
        Ein Cookie ist ein kurzes Datenpaket, welches zwischen Webbrowser und Webserver ausgetauscht wird, für diese aber völlig bedeutungslos ist und erst für die Webanwendung, z. B. einen Online-Shop, eine Bedeutung erhält, etwa den Inhalt eines virtuellen Warenkorbes.
      </p>
      <p>
        Es gibt zwei Arten von Cookies: Erstanbieter-Cookies werden von unserer Website erstellt, Drittanbieter-Cookies werden von anderen Websites (z. B. Google Analytics) erstellt.
        Beispielhafte Cookiedaten:
      <ul>
        <li>Name: _ga</li>
        <li>Ablaufzeit: 2 Jahre</li>
        <li>Verwendung: Unterscheidung der Webseitenbesucher</li>
        <li>Beispielhafter Wert: GA1.2.1326744211.152211087012</li>
      </ul>
      Man unterscheidet drei Kategorien von Cookies: unbedingt notwendige Cookies um grundlegende Funktionen der Website sicherzustellen, funktionelle Cookies um die Leistung der Webseite sicherzustellen und zielorientierte Cookies um das Benutzererlebnis zu verbessern.
      </p>
      <p>
        Wir nutzen Cookies, um unsere Webseite nutzerfreundlicher zu gestalten. Einige Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese löschen. Sie ermöglichen es uns, Ihren Browser beim nächsten Besuch wiederzuerkennen.
      </p>
      <h3>Cookie Einstellungen sehen und Cookies löschen</h3>
      <p>
        Wenn Sie feststellen möchten, welche Cookies in Ihrem Browser gespeichert wurden, Cookie-Einstellungen ändern oder Cookies löschen möchten, können Sie dies in Ihren Browser-Einstellungen finden:
      <ul>
        <li>Safari: Verwalten von Cookies und Websitedaten mit Safari</li>
        <li>Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf Ihrem Computer abgelegt haben</li>
        <li>Chrome: Cookies in Chrome löschen, aktivieren und verwalten</li>
        <li>Internet Explorer: Löschen und Verwalten von Cookies</li>
      </ul>
      Wenn Sie die Speicherung von Daten in Cookies nicht wünschen, so können Sie Ihren Browser so einrichten, dass er Sie über das Setzen von Cookies informiert und Sie dies nur im Einzelfall erlauben. Sie können jederzeit Cookies, die sich bereits auf Ihrem Computer befinden, löschen oder Cookies deaktivieren. Die Vorgangsweise dazu ist nach Browser unterschiedlich, am besten Sie suchen die Anleitung in Google mit dem Suchbegriff “Cookies löschen Chrome” oder „Cookies deaktivieren Chrome“ im Falle eines Chrome Browsers oder tauschen das Wort „Chrome“ gegen den Namen Ihres Browsers, z. B. Edge, Firefox, Safari aus.
      Wenn Sie uns generell nicht gestatten, Cookies zu nutzen, d.h. diese per Browsereinstellung deaktivieren, können manche Funktionen und Seiten nicht wie erwartet funktionieren.
      </p>
      <script id="CookieDeclaration" src="https://consent.cookiebot.com/d49de91b-4a0b-4c9c-886c-a3b7e269edeb/cd.js" type="text/javascript" async></script>
      <h3>Cookies von Google Analytics</h3>
      <p>
      <ul>
        <li>_ga</li>
        <ul>
          <li>Ablaufzeit: 2 Jahre</li>
          <li>Verwendung: Unterscheidung der Webseitenbesucher</li>
          <li>Beispielhafter Wert: GA1.2.1326744211.152211087012</li>
        </ul>
        <li>_gid</li>
        <ul>
          <li>Ablaufzeit: 24 Stunden</li>
          <li>Verwendung: Unterscheidung der Webseitenbesucher</li>
          <li>Beispielhafter Wert: GA1.2.1687193234.152211087012</li>
        </ul>
        <li>_gat_gtag_UA_</li>
        <ul>
          <li>Ablaufzeit: 1 Minute</li>
          <li>Verwendung: Wird zum Drosseln der Anforderungsrate verwendet. Wenn Google Analytics über den Google Tag Manager bereitgestellt wird, erhält dieser Cookie den Namen _dc_gtm_.</li>
          <li>Beispielhafter Wert: 1</li>
        </ul>
      </ul>
      Nähere Informationen zu Nutzungsbedingungen und Datenschutz finden Sie unter http://www.google.com/analytics/terms/de.html bzw. unter https://support.google.com/analytics/answer/6004245?hl=de.
      </p>
      <h3>Pseudonymisierung</h3>
      <p>
        Unser Anliegen im Sinne der DSGVO ist die Verbesserung unseres Angebotes und unseres Webauftritts. Da uns die Privatsphäre unserer Nutzer wichtig ist, werden die Nutzerdaten pseudonymisiert. Die Datenverarbeitung erfolgt auf Basis der gesetzlichen Bestimmungen des § 96 Abs 3 TKG sowie des Art 6 EU-DSGVO Abs 1 lit a (Einwilligung) und/oder f (berechtigtes Interesse) der DSGVO.
      </p>
      <h3>Deaktivierung der Datenerfassung durch Google Analytics</h3>
      <p>
        Mithilfe des Browser-Add-ons zur Deaktivierung von Google Analytics-JavaScript (ga.js, analytics.js, dc.js) können Website-Besucher verhindern, dass Google Analytics ihre Daten verwendet.

        Sie können die Erfassung der durch das Cookie erzeugten und auf Ihre Nutzung der Website bezogenen Daten an Google sowie die Verarbeitung dieser Daten durch Google verhindern, indem Sie das unter dem folgenden Link verfügbare Browser-Plugin herunterladen und installieren: https://tools.google.com/dlpage/gaoptout?hl=de
      </p>
      <h2>Google Analytics IP-Anonymisierung</h2>
      <p>
        Wir haben auf dieser Webseite die IP-Adressen-Anonymisierung von Google Analytics implementiert. Diese Funktion wurde von Google entwickelt, damit diese Webseite die geltenden Datenschutzbestimmungen und Empfehlungen der lokalen Datenschutzbehörden einhalten kann, wenn diese eine Speicherung der vollständigen IP-Adresse untersagen. Die Anonymisierung bzw. Maskierung der IP findet statt, sobald die IP-Adressen im Google Analytics-Datenerfassungsnetzwerk eintreffen und bevor eine Speicherung oder Verarbeitung der Daten stattfindet.
      </p>
      <p>
        Mehr Informationen zur IP-Anonymisierung finden Sie auf https://support.google.com/analytics/answer/2763052?hl=de.
      </p>
      <p>
        Google Analytics Berichte zu demografischen Merkmalen und Interessen
        Wir haben in Google Analytics die Funktionen für Werbeberichte eingeschaltet. Die Berichte zu demografischen Merkmalen und Interessen enthalten Angaben zu Alter, Geschlecht und Interessen. Damit können wir uns – ohne diese Daten einzelnen Personen zuordnen zu können – ein besseres Bild von unseren Nutzern machen. Mehr über die Werbefunktionen erfahren Sie auf https://support.google.com/analytics/answer/3450482?hl=de_AT&utm_id=ad.
      </p>
      <p>
        Sie können die Nutzung der Aktivitäten und Informationen Ihres Google Kontos unter “Einstellungen für Werbung” auf https://adssettings.google.com/authenticated per Checkbox beenden.
      </p>
      <h2>Google Fonts</h2>
      <p>
        Wir verwenden Google Fonts der Firma Google Inc. (1600 Amphitheatre Parkway Mountain View, CA 94043, USA) auf unserer Webseite. Die Verwendung von Google Fonts erfolgt ohne Authentisierung und es werden keine Cookies an die Google Fonts API gesendet. Sollten Sie ein Konto bei Google haben, werden keine Ihrer Google-Kontodaten an Google während der Nutzung von Google Fonts übermittelt. Google erfasst lediglich die Nutzung von CSS und der verwendeten Fonts und speichert diese Daten sicher. Mehr zu diesen und weiteren Fragen finden Sie auf https://developers.google.com/fonts/faq?tid=211087012.

        Welche Daten von Google erfasst werden und wofür diese Daten verwendet werden, können Sie auf https://www.google.com/intl/de/policies/privacy/ nachlesen.
      </p>
      -->
      <h2>Webanalyse mittels Matomo (vormals Piwik)</h2>
      <h3>Umfang der Verarbeitung personenbezogener Daten</h3>
      <p>Wir nutzen auf dieser Website die Software „Matomo“ (www.matomo.org), einem Dienst des Anbieters InnoCraft Ltd.,
        150 Willis St, 6011 Wellington, Neuseeland. Werden Unterseiten unserer Webseite aufgerufen, so werden folgende
        Daten gespeichert:</p>
      <ul>
        <li>die IP-Adresse des Nutzers, gekürzt um die letzten zwei Bytes (anonymisiert)</li>
        <li>die aufgerufene Unterseite und Zeitpunkt des Aufrufs</li>
        <li>die Seite, von der der Nutzer auf unsere Webseite gelangt ist (Referrer)</li>
        <li>welcher Browser mit welchen Plugins, welches Betriebssystem und welche Bildschirmauflösung genutzt wird</li>
        <li>die Verweildauer auf der Website</li>
        <li>die Seiten, die von der aufgerufenen Unterseite aus angesteuert werden</li>
      </ul>
      <p>Die mit Matomo erhobenen Daten werden werden auf unseren eigenen Servern gespeichert. Eine Weitergabe an Dritte
        erfolgt nicht.</p>

      <h3>Rechtsgrundlage</h3>
      <p>Die Rechtsgrundlage, auf der wir mittels Matomo personenbezogene Daten verarbeiten, ist Art. 6 Abs. 1 lit. f der
        DSGVO.</p>

      <h3>Zweck der Datenverarbeitung</h3>
      <p>Wir benötigen die Daten, um das Surfverhalten der Nutzer zu analysieren und Informationen über Nutzung der
        einzelnen Komponenten der Website zu erhalten. Das ermöglicht uns, die Website und ihre Nutzerfreundlichkeit
        stetig zu optimieren. In diesen Zwecken liegt unser berechtigtes Interesse nach Art. 6 Abs. 1 lit. f DSGVO
        begründet. Durch die Anonymisierung der IP-Adresse tragen wir dem Interesse der Nutzer am Schutz personenbezogener
        Daten Rechnung. Die Daten werden nie dazu genutzt, den Nutzer der Website persönlich zu identifizieren und werden
        nicht mit anderen Daten zusammengeführt.</p>

      <h3>Dauer der Speicherung</h3>
      <p>Die Daten werden gelöscht, wenn sie für unsere Zwecke nicht mehr benötigt werden.</p>

      <h3>Widerspruchsmöglichkeit</h3>
      <p>Gegen die Aufzeichnung der Daten in der oben beschriebenen Weise können Sie auf drei verschiedene Weisen
        Widerspruch einlegen:</p>
      <ul>
        <li>1. Sie können die Ablage von Cookies in ihrem Browser ganz unterbinden. Das führt allerdings dazu, dass Sie
          möglicherweise manche Funktionen unserer Website nicht mehr nutzen können, die zwingend eine Identifizierung
          voraussetzen (Warenkorb, Bestellungen, persönliche Einstellungen o.ä.)</li>
        <li>2. Sie können die Einstellung „Do-not-Track“ in Ihrem Browser aktivieren. Unser Matomo-System ist so
          konfiguriert, dass es diese Einstellung respektiert.</li>
        <li>3. Sie können mit einem Mausklick unten ein so genanntes Opt-Out-Cookie anlegen, das zwei Jahre Gültigkeit
          hat. Es hat zur Folge, dass Matomo Ihre weiteren Besuche nicht registrieren wird. Beachten Sie allerdings, dass
          das Opt-Out-Cookie gelöscht wird, wenn Sie alle Cookies löschen.</li>
      </ul>
      <h2>Server Logs</h2>
      <p>
        Wenn Sie diese Webseite verwenden, wird der Aufruf vom Host der Webseite (<a href="https://www.ionos.de/"
          target="_blank">IONOS</a>) aufgezeichnet. Dieses Log enthält Ihre IP-Adresse, welche Sie indirekt über Ihren
        Internetanbieter identifiziert. Die Aufzeichnung dieser Daten ist gesetzlich verpflichtend und für die Sicherheit
        notwendig. Es gibt keine Möglichkeit zum Opt-Out, die Daten werden aber niemals für andere Zwecke verwendet.
      </p>

      <!--
      <h2>Affiliatelinks/Werbelinks</h2>
      <p>
        Die mit Sternchen (*) gekennzeichneten Links sind sogenannte Affiliate-Links. Wenn du auf so einen Affiliate-Link klickst und über diesen Link einkaufst, bekommt der Seitenbetreiber von dem betreffenden Online-Shop oder Anbieter eine Provision. Für dich verändert sich der Preis nicht.
      </p>

      <h2>Amazon Partnerprogramm</h2>
      <p>
        Die Betreiber der Seiten nehmen am Amazon EU-Partnerprogramm teil. Auf unseren Seiten werden durch Amazon Werbeanzeigen und Links zur Seite von Amazon.de eingebunden, an denen wir über Werbekostenerstattung Geld verdienen können.
      </p>
      <p>
        Beim Klick auf Affiliatelinks/Werbelinks von Amazon gelangen Sie zu Amazon und dort gelten die Geschäftsbedingungen und die Richtlinien zur Datenverarbeitung von Amazon. Amazon setzt im eigenen Shop Cookies oder vergleichbare Wiedererkennungstechnologien (z.B. Device-Fingerprinting) ein, um die Herkunft der Bestellungen nachvollziehen zu können. Dadurch kann Amazon erkennen, dass Sie den Partnerlink auf dieser Website geklickt haben.
      </p>
      <p>
        Weitere Informationen zur Datennutzung durch Amazon erhalten Sie in der <a href="https://www.amazon.de/gp/help/customer/display.html/ref=footer_privacy?ie=UTF8&nodeId=3312401" target="_blank">Datenschutzerklärung von Amazon</a>.
      </p>
      -->

      <h2>Google Adsense</h2>

      <h3>Was ist Google AdSense?</h3>
      <p>Wir verwenden auf dieser Website Google AdSense. Das ist ein Anzeigenprogramm der Firma Google Inc. In Europa ist
        das Unternehmen Google Ireland Limited (Gordon House, Barrow Street Dublin 4, Irland) für alle Google-Dienste
        verantwortlich. Mit Google AdSense können wir auf dieser Webseite Werbeanzeigen einblenden, die zu unserem Thema
        passen. So bieten wir Ihnen Anzeigen, die im Idealfall einen richtigen Mehrwert für Sie darstellen. Im Zuge dieses
        Datenschutztextes über Google AdSense erklären wir Ihnen, warum wir Google AdSense auf unserer Website verwenden,
        welche Ihrer Daten verarbeitet und gespeichert werden und wie Sie diese Datenspeicherung unterbinden können.</p>

      <p>Das Werbeprogramm Google AdSense gibt es mittlerweile seit 2003. Im Gegensatz zu Google Ads (früher: Google
        AdWords) kann man hier nicht selbst Werbung schalten. Über Google AdSense werden Werbeanzeigen auf Websites, wie
        zum Beispiel auf unserer, ausgespielt. Der größte Vorteil dieses Werbedienstes im Vergleich zu manch anderen ist,
        dass Ihnen Google AdSense nur Anzeigen zeigt, die zu unseren Inhalten passen. Google hat einen eigenen
        Algorithmus, der berechnet, welche Werbeanzeigen Sie zu Gesicht bekommen. Natürlich wollen wir Ihnen nur Werbung
        zeigen, die Sie auch interessiert und einen Mehrwert bietet. Google überprüft anhand Ihrer Interessen bzw. Ihres
        Userverhaltens und anhand unseres Angebots, welche Werbeanzeigen für unsere Website und für unsere User geeignet
        sind. An dieser Stelle wollen wir auch gleich erwähnen, dass wir für die Auswahl der Werbeanzeigen nicht
        verantwortlich sind. Wir bieten mit unserer Website lediglich die Werbefläche an. Die Auswahl der angezeigten
        Werbung trifft Google. Seit August 2013 werden die Anzeigen auch an die jeweilige Benutzeroberfläche angepasst.
        Das heißt, egal ob Sie von Ihrem Smartphone, Ihrem PC oder Laptop unsere Website besuchen, die Anzeigen passen
        sich an Ihr Endgerät an.</p>

      <h3>Warum verwenden wir Google AdSense auf unserer Website?</h3>
      <p>Das Betreiben einer hochwertigen Website erfordert viel Hingabe und großen Einsatz. Im Grunde sind wir mit der
        Arbeit an unserer Website nie fertig. Wir versuchen stets unsere Seite zu pflegen und so aktuell wie möglich zu
        halten. Natürlich wollen wir mit dieser Arbeit auch einen wirtschaftlichen Erfolg erzielen. Darum haben wir uns
        für Werbeanzeigen als Einnahmequelle entschieden. Das Wichtigste für uns ist allerdings, Ihren Besuch auf unserer
        Website durch diese Anzeigen nicht zu stören. Mithilfe von Google AdSense wird Ihnen nur Werbung angeboten, die zu
        unseren Themen und Ihren Interessen passt.</p>

      <p>Ähnlich wie bei der Google-Indexierung für eine Website, untersucht ein Bot den entsprechenden Content und die
        entsprechenden Angebote auf der Seite. Dann werden die Werbeanzeigen inhaltlich angepasst und präsentiert. Neben
        den inhaltlichen Überschneidungen zwischen Anzeige und Website-Angebot unterstützt AdSense auch
        interessensbezogenes Targeting. Das bedeutet, dass Google auch Ihre Daten dazu verwendet, um auf Sie
        zugeschnittene Werbung anzubieten. So erhalten Sie Werbung, die Ihnen im Idealfall einen echten Mehrwert bietet
        und wir haben eine höhere Chance ein bisschen etwas zu verdienen.</p>

      <h3>Welche Daten werden von Google AdSense gespeichert?</h3>
      <p>Damit Google AdSense eine maßgeschneiderte, auf Sie angepasste Werbung anzeigen kann, werden unter anderem
        Cookies verwendet. Cookies sind kleine Textdateien, die bestimmte Informationen auf Ihrem Computer speichern.</p>

      <p>In AdSense sollen Cookies bessere Werbung ermöglichen. Die Cookies enthalten keine personenidentifizierbaren
        Daten. Hierbei ist allerdings zu beachten, dass Google Daten wie zum Beispiel “Pseudonyme Cookie-IDs” (Name oder
        ein anderes Identifikationsmerkmal wird durch ein Pseudonym ersetzt) oder IP-Adressen als nicht
        personenidentifizierbare Informationen ansieht. Im Rahmen der DSGVO können diese Daten allerdings als
      personenbezogene Daten gelten. Google AdSense sendet nach jeder Impression (das ist immer dann der Fall, wenn Sie
      eine Anzeige sehen), jedem Klick und jeder anderen Aktivität, die zu einem Aufruf der Google-AdSense-Server führt,
      ein Cookie an den Browser. Sofern der Browser das Cookie akzeptiert, wird es dort gespeichert.</p>

    <p>Drittanbieter können im Rahmen von AdSense unter Umständen Cookies in Ihrem Browser platzieren und auslesen bzw.
      Web-Beacons verwenden, um Daten zu speichern, die sie durch die Anzeigenbereitstellung auf der Website erhalten.
      Als Web-Beacons bezeichnet man kleine Grafiken, die eine Logdatei-Analyse und eine Aufzeichnung der Logdatei
      machen. Diese Analyse ermöglicht eine statistische Auswertung für das Online-Marketing.</p>

    <p>Google kann über diese Cookies bestimmte Informationen über Ihr Userverhalten auf unserer Website sammeln. Dazu
      zählen:</p>

    <ul>
      <li>Informationen wie Sie mit einer Anzeige umgehen (Klicks, Impression, Mausbewegungen)</li>
      <li>Informationen, ob in Ihrem Browser schon eine Anzeige zu einem früheren Zeitpunkt erschienen ist. Diese Daten
        helfen dabei, Ihnen eine Anzeige nicht öfter anzuzeigen.</li>
    </ul>

    <p>Dabei analysiert Google die Daten zu den angezeigten Werbemitteln und Ihre IP-Adresse und wertet diese aus.
      Google verwendet die Daten in erster Linie, um die Effektivität einer Anzeige zu messen und das Werbeangebot zu
      verbessern. Diese Daten werden nicht mit personenbezogenen Daten, die Google möglicherweise über andere
      Google-Dienste von Ihnen hat, verknüpft.</p>

    <h3>Wie lange und wo werden die Daten gespeichert?</h3>
    <p>Google erfasst Ihre IP-Adresse und verschiedene Aktivitäten, die Sie auf der Website ausführen. Cookies speichern
      diese Informationen zu den Interaktionen auf unserer Website. Laut Google sammelt und speichert das Unternehmen
      die angegebenen Informationen auf sichere Weise auf den hauseigenen Google-Servern in den USA.</p>

    <p>Wenn Sie kein Google-Konto haben bzw. nicht angemeldet sind, speichert Google die erhobenen Daten mit einer
      eindeutigen Kennung (ID) meist auf Ihrem Browser. Die in Cookies gespeicherten eindeutigen IDs dienen
      beispielsweise dazu, personalisierte Werbung zu gewährleisten. Wenn Sie in einem Google-Konto angemeldet sind,
      kann Google auch personenbezogene Daten erheben.</p>

    <p>Einige der Daten, die Google speichert, können Sie jederzeit wieder löschen (siehe nächsten Abschnitt). Viele
      Informationen, die in Cookies gespeichert sind, werden automatisch nach einer bestimmten Zeit wieder gelöscht. Es
      gibt allerdings auch Daten, die von Google über einen längeren Zeitraum gespeichert werden. Dies ist dann der
      Fall, wenn Google aus wirtschaftlichen oder rechtlichen Notwendigkeiten, gewisse Daten über einen unbestimmten
      längeren Zeitraum speichern muss.</p>

    <h3>Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?</h3>
    <p>Sie haben immer die Möglichkeit Cookies, die sich auf Ihrem Computer befinden, zu löschen oder zu deaktivieren.
      Wie genau das funktioniert hängt von Ihrem Browser ab. Unter dem Abschnitt „Cookies“ finden Sie die entsprechenden
      Links zu den jeweiligen Anleitungen der bekanntesten Browser.</p>

    <p>Falls Sie grundsätzlich keine Cookies haben wollen, können Sie Ihren Browser so einrichten, dass er Sie immer
      informiert, wenn ein Cookie gesetzt werden soll. So können Sie bei jedem einzelnen Cookie entscheiden, ob Sie das
      Cookie erlauben oder nicht. Durch das Herunterladen und Installieren dieses Browser-Plug-ins auf
      https://support.google.com/ads/answer/7395996 werden ebenfalls alle „Werbecookies“ deaktiviert. Bedenken Sie, dass
      Sie durch das Deaktivieren dieser Cookies nicht die Werbeanzeigen verhindern, sondern nur die personalisierte
      Werbung.</p>

    <p>Wenn Sie ein Google Konto besitzen, können Sie auf der Website https://adssettings.google.com/authenticated
      personalisierte Werbung deaktivieren. Auch hier sehen Sie dann weiter Anzeigen, allerdings sind diese nicht mehr
      an Ihre Interessen angepasst. Dennoch werden die Anzeigen auf der Grundlage von ein paar Faktoren, wie Ihrem
      Standort, dem Browsertyp und der verwendeten Suchbegriffe, angezeigt.</p>

    <h3>Rechtsgrundlage</h3>
    <p>Wenn Sie eingewilligt haben, dass Google AdSense eingesetzt werden darf, ist die Rechtsgrundlage der
      entsprechenden Datenverarbeitung diese Einwilligung. Diese Einwilligung stellt laut Art. 6 Abs. 1 lit. a DSGVO
      (Einwilligung) die Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie bei der Erfassung durch
      Google AdSense vorkommen kann, dar.</p>

    <p>Von unserer Seite besteht zudem ein berechtigtes Interesse, Google AdSense zu verwenden, um unser Online-Service
      und unsere Marketingmaßnahmen zu optimieren. Die dafür entsprechende Rechtsgrundlage ist Art. 6 Abs. 1 lit. f
      DSGVO (Berechtigte Interessen). Wir setzen Google AdSense gleichwohl nur ein, soweit Sie eine Einwilligung erteilt
      haben.</p>

    <p>Google verarbeitet Daten von Ihnen u.a. auch in den USA. Wir weisen darauf hin, dass nach Meinung des
      Europäischen Gerichtshofs derzeit kein angemessenes Schutzniveau für den Datentransfer in die USA besteht. Dies
      kann mit verschiedenen Risiken für die Rechtmäßigkeit und Sicherheit der Datenverarbeitung einhergehen.</p>

    <p>Als Grundlage der Datenverarbeitung bei Empfängern mit Sitz in Drittstaaten (außerhalb der Europäischen Union,
      Island, Liechtenstein, Norwegen, also insbesondere in den USA) oder einer Datenweitergabe dorthin verwendet Google
      sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3 DSGVO). Standardvertragsklauseln (Standard
      Contractual Clauses – SCC) sind von der EU-Kommission bereitgestellte Mustervorlagen und sollen sicherstellen,
      dass Ihre Daten auch dann den europäischen Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
      beispielsweise in die USA) überliefert und dort gespeichert werden. Durch diese Klauseln verpflichtet sich Google,
      bei der Verarbeitung Ihrer relevanten Daten, das europäische Datenschutzniveau einzuhalten, selbst wenn die Daten
      in den USA gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf einem Durchführungsbeschluss
      der EU-Kommission. Sie finden den Beschluss und die entsprechenden Standardvertragsklauseln u.a. hier:
      https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de</p>

    <p>Die Datenverarbeitungsbedingungen für Google Werbeprodukte (Google Ads Controller-Controller Data Protection
      Terms), welche den Standardvertragsklauseln entsprechen und auch für Google AdSense geltend sind, finden Sie unter
      https://business.safety.google/adscontrollerterms/.</p>

    <p>Welche Daten Google grundsätzlich erfasst und wofür sie diese Daten verwenden, können Sie auf
      https://www.google.com/intl/de/policies/privacy/ nachlesen.</p>

    <p>
      Quelle: Teilweise erstellt mit dem Datenschutz Generator von firmenwebseiten.at in Kooperation mit walletx.at
    </p>
  </div>
</div></template>

<script>
export default {
  name: 'data-policy',
  metaInfo: {
    title: 'Datenschutzerklärung',
    meta: [
      {
        name: 'description',
        content: 'Die Datenschutzerklärung von Elektrotechnik-Rechner.at.'
      },
      {
        name: 'robots',
        content: 'noindex,nofollow'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: 'Datenschutzerklärung', route: 'start' })
  }
}
</script>
